"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "asti": {
    "22990549": [{
      "hkey": "d432e0d9",
      "slug": "bremairate-palucco-revignano-valleandona",
      "name": "Bremairate-Palucco-Revignano-Valleandona",
      "primary": true,
      "skipSearch": false
    }],
    "bramairate": [{
      "hkey": "d432e0d9",
      "slug": "bremairate-palucco-revignano-valleandona",
      "name": "Bremairate-Palucco-Revignano-Valleandona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "84632dbf": [{
      "hkey": "d432e0d9",
      "slug": "bremairate-palucco-revignano-valleandona",
      "name": "Bremairate-Palucco-Revignano-Valleandona",
      "primary": true,
      "skipSearch": false
    }],
    "bricco-fassio": [{
      "hkey": "d432e0d9",
      "slug": "bremairate-palucco-revignano-valleandona",
      "name": "Bremairate-Palucco-Revignano-Valleandona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "bf839981": [{
      "hkey": "0f517929",
      "slug": "serravalle-mombarone",
      "name": "Serravalle-Mombarone",
      "primary": true,
      "skipSearch": false
    }],
    "bricco-roasio": [{
      "hkey": "0f517929",
      "slug": "serravalle-mombarone",
      "name": "Serravalle-Mombarone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "c31d5adf": [{
      "hkey": "f1945005",
      "slug": "valgera-valleversa-caniglie",
      "name": "Valgera-Valleversa-Caniglie",
      "primary": true,
      "skipSearch": false
    }],
    "ca-dei-coppi": [{
      "hkey": "f1945005",
      "slug": "valgera-valleversa-caniglie",
      "name": "Valgera-Valleversa-Caniglie",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "5d8a49df": [{
      "hkey": "f1945005",
      "slug": "valgera-valleversa-caniglie",
      "name": "Valgera-Valleversa-Caniglie",
      "primary": true,
      "skipSearch": false
    }],
    "caniglie": [{
      "hkey": "f1945005",
      "slug": "valgera-valleversa-caniglie",
      "name": "Valgera-Valleversa-Caniglie",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "6f5a28b5": [{
      "hkey": "4385d9e3",
      "slug": "san-marzanotto-torrazzo-carretti-montemarzo",
      "name": "San Marzanotto-Torrazzo-Carretti-Montemarzo",
      "primary": true,
      "skipSearch": false
    }],
    "carretti": [{
      "hkey": "4385d9e3",
      "slug": "san-marzanotto-torrazzo-carretti-montemarzo",
      "name": "San Marzanotto-Torrazzo-Carretti-Montemarzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "a7403e44": [{
      "hkey": "ee9abc66",
      "slug": "asti-citta",
      "name": "Asti Città",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "ee9abc66",
      "slug": "asti-citta",
      "name": "Asti Città",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "48f545ff": [{
      "hkey": "0ad561b6",
      "slug": "corso-alessandria-corso-casale",
      "name": "Corso Alessandria-Corso Casale",
      "primary": true,
      "skipSearch": false
    }],
    "est-praia-pilone": [{
      "hkey": "0ad561b6",
      "slug": "corso-alessandria-corso-casale",
      "name": "Corso Alessandria-Corso Casale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "asti-citta"
    }],
    "819db25a": [{
      "hkey": "b8d39d47",
      "slug": "madonna-di-viatosto-valmanera",
      "name": "Madonna di Viatosto-Valmanera",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-di-viatosto": [{
      "hkey": "b8d39d47",
      "slug": "madonna-di-viatosto-valmanera",
      "name": "Madonna di Viatosto-Valmanera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3eedcc81": [{
      "hkey": "0f517929",
      "slug": "serravalle-mombarone",
      "name": "Serravalle-Mombarone",
      "primary": true,
      "skipSearch": false
    }],
    "mombarone": [{
      "hkey": "0f517929",
      "slug": "serravalle-mombarone",
      "name": "Serravalle-Mombarone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "ac5b7d09": [{
      "hkey": "22ad70cc",
      "slug": "asti",
      "name": "Asti",
      "primary": true,
      "skipSearch": false
    }],
    "mongardino-stazione": [{
      "hkey": "22ad70cc",
      "slug": "asti",
      "name": "Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1e3dab06": [{
      "hkey": "4385d9e3",
      "slug": "san-marzanotto-torrazzo-carretti-montemarzo",
      "name": "San Marzanotto-Torrazzo-Carretti-Montemarzo",
      "primary": true,
      "skipSearch": false
    }],
    "montemarzo": [{
      "hkey": "4385d9e3",
      "slug": "san-marzanotto-torrazzo-carretti-montemarzo",
      "name": "San Marzanotto-Torrazzo-Carretti-Montemarzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "09b88052": [{
      "hkey": "54943ccb",
      "slug": "ospedale-stadio",
      "name": "Ospedale-Stadio",
      "primary": true,
      "skipSearch": false
    }],
    "nord-maternita": [{
      "hkey": "54943ccb",
      "slug": "ospedale-stadio",
      "name": "Ospedale-Stadio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "asti-citta"
    }],
    "a5feb61f": [{
      "hkey": "22ad70cc",
      "slug": "asti",
      "name": "Asti",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-d-asti": [{
      "hkey": "22ad70cc",
      "slug": "asti",
      "name": "Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "66a5c0c0": [{
      "hkey": "783f6169",
      "slug": "quarto-valenzani",
      "name": "Quarto-Valenzani",
      "primary": true,
      "skipSearch": false
    }],
    "quarto": [{
      "hkey": "783f6169",
      "slug": "quarto-valenzani",
      "name": "Quarto-Valenzani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8ada68d3": [{
      "hkey": "783f6169",
      "slug": "quarto-valenzani",
      "name": "Quarto-Valenzani",
      "primary": true,
      "skipSearch": false
    }],
    "quarto-superiore": [{
      "hkey": "783f6169",
      "slug": "quarto-valenzani",
      "name": "Quarto-Valenzani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "b3c31653": [{
      "hkey": "d432e0d9",
      "slug": "bremairate-palucco-revignano-valleandona",
      "name": "Bremairate-Palucco-Revignano-Valleandona",
      "primary": true,
      "skipSearch": false
    }],
    "revignano": [{
      "hkey": "d432e0d9",
      "slug": "bremairate-palucco-revignano-valleandona",
      "name": "Bremairate-Palucco-Revignano-Valleandona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "bd619d3f": [{
      "hkey": "22ad70cc",
      "slug": "asti",
      "name": "Asti",
      "primary": true,
      "skipSearch": false
    }],
    "rioscone": [{
      "hkey": "22ad70cc",
      "slug": "asti",
      "name": "Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e4e0c0ab": [{
      "hkey": "9e4b1dff",
      "slug": "sessant-san-grato",
      "name": "Sessant-San Grato",
      "primary": true,
      "skipSearch": false
    }],
    "san-grato-di-sessant": [{
      "hkey": "9e4b1dff",
      "slug": "sessant-san-grato",
      "name": "Sessant-San Grato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "e3419181": [{
      "hkey": "4385d9e3",
      "slug": "san-marzanotto-torrazzo-carretti-montemarzo",
      "name": "San Marzanotto-Torrazzo-Carretti-Montemarzo",
      "primary": true,
      "skipSearch": false
    }],
    "san-marzanotto": [{
      "hkey": "4385d9e3",
      "slug": "san-marzanotto-torrazzo-carretti-montemarzo",
      "name": "San Marzanotto-Torrazzo-Carretti-Montemarzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "37df6351": [{
      "hkey": "4385d9e3",
      "slug": "san-marzanotto-torrazzo-carretti-montemarzo",
      "name": "San Marzanotto-Torrazzo-Carretti-Montemarzo",
      "primary": true,
      "skipSearch": false
    }],
    "san-marzanotto-piana": [{
      "hkey": "4385d9e3",
      "slug": "san-marzanotto-torrazzo-carretti-montemarzo",
      "name": "San Marzanotto-Torrazzo-Carretti-Montemarzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "6db2122f": [{
      "hkey": "22ad70cc",
      "slug": "asti",
      "name": "Asti",
      "primary": true,
      "skipSearch": false
    }],
    "san-vito-poggio": [{
      "hkey": "22ad70cc",
      "slug": "asti",
      "name": "Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "536c5585": [{
      "hkey": "22ad70cc",
      "slug": "asti",
      "name": "Asti",
      "primary": true,
      "skipSearch": false
    }],
    "santo-spirito": [{
      "hkey": "22ad70cc",
      "slug": "asti",
      "name": "Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9a95db65": [{
      "hkey": "0f517929",
      "slug": "serravalle-mombarone",
      "name": "Serravalle-Mombarone",
      "primary": true,
      "skipSearch": false
    }],
    "serravalle": [{
      "hkey": "0f517929",
      "slug": "serravalle-mombarone",
      "name": "Serravalle-Mombarone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "520e5710": [{
      "hkey": "9e4b1dff",
      "slug": "sessant-san-grato",
      "name": "Sessant-San Grato",
      "primary": true,
      "skipSearch": false
    }],
    "sessant": [{
      "hkey": "9e4b1dff",
      "slug": "sessant-san-grato",
      "name": "Sessant-San Grato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5a5bed02": [{
      "hkey": "48ecadd9",
      "slug": "stazione-di-portacomaro-valmaggiore",
      "name": "Stazione di Portacomaro-Valmaggiore",
      "primary": true,
      "skipSearch": false
    }],
    "stazione-portacomaro": [{
      "hkey": "48ecadd9",
      "slug": "stazione-di-portacomaro-valmaggiore",
      "name": "Stazione di Portacomaro-Valmaggiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9831a2ac": [{
      "hkey": "a5dde490",
      "slug": "vaglierano",
      "name": "Vaglierano",
      "primary": true,
      "skipSearch": false
    }],
    "stazione-san-damiano": [{
      "hkey": "a5dde490",
      "slug": "vaglierano",
      "name": "Vaglierano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "77287b5b": [{
      "hkey": "4ee012b6",
      "slug": "corso-alba",
      "name": "Corso Alba",
      "primary": true,
      "skipSearch": false
    }],
    "sud": [{
      "hkey": "4ee012b6",
      "slug": "corso-alba",
      "name": "Corso Alba",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "asti-citta"
    }],
    "f74693cd": [{
      "hkey": "4385d9e3",
      "slug": "san-marzanotto-torrazzo-carretti-montemarzo",
      "name": "San Marzanotto-Torrazzo-Carretti-Montemarzo",
      "primary": true,
      "skipSearch": false
    }],
    "torrazzo": [{
      "hkey": "4385d9e3",
      "slug": "san-marzanotto-torrazzo-carretti-montemarzo",
      "name": "San Marzanotto-Torrazzo-Carretti-Montemarzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "e845c590": [{
      "hkey": "8e8f8015",
      "slug": "corso-savona-trincere",
      "name": "Corso Savona-Trincere",
      "primary": true,
      "skipSearch": false
    }],
    "trincere": [{
      "hkey": "8e8f8015",
      "slug": "corso-savona-trincere",
      "name": "Corso Savona-Trincere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "asti-citta"
    }],
    "41211a09": [{
      "hkey": "783f6169",
      "slug": "quarto-valenzani",
      "name": "Quarto-Valenzani",
      "primary": true,
      "skipSearch": false
    }],
    "valenzani": [{
      "hkey": "783f6169",
      "slug": "quarto-valenzani",
      "name": "Quarto-Valenzani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "2b5eba48": [{
      "hkey": "783f6169",
      "slug": "quarto-valenzani",
      "name": "Quarto-Valenzani",
      "primary": true,
      "skipSearch": false
    }],
    "valfea": [{
      "hkey": "783f6169",
      "slug": "quarto-valenzani",
      "name": "Quarto-Valenzani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "a43be6f3": [{
      "hkey": "f1945005",
      "slug": "valgera-valleversa-caniglie",
      "name": "Valgera-Valleversa-Caniglie",
      "primary": true,
      "skipSearch": false
    }],
    "valgera": [{
      "hkey": "f1945005",
      "slug": "valgera-valleversa-caniglie",
      "name": "Valgera-Valleversa-Caniglie",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e146a551": [{
      "hkey": "d432e0d9",
      "slug": "bremairate-palucco-revignano-valleandona",
      "name": "Bremairate-Palucco-Revignano-Valleandona",
      "primary": true,
      "skipSearch": false
    }],
    "valle-andona": [{
      "hkey": "d432e0d9",
      "slug": "bremairate-palucco-revignano-valleandona",
      "name": "Bremairate-Palucco-Revignano-Valleandona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "fdcb6c45": [{
      "hkey": "22ad70cc",
      "slug": "asti",
      "name": "Asti",
      "primary": true,
      "skipSearch": false
    }],
    "valle-tanaro": [{
      "hkey": "22ad70cc",
      "slug": "asti",
      "name": "Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "db7de7cc": [{
      "hkey": "48ecadd9",
      "slug": "stazione-di-portacomaro-valmaggiore",
      "name": "Stazione di Portacomaro-Valmaggiore",
      "primary": true,
      "skipSearch": false
    }],
    "valmaggiore": [{
      "hkey": "48ecadd9",
      "slug": "stazione-di-portacomaro-valmaggiore",
      "name": "Stazione di Portacomaro-Valmaggiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "eb1d1890": [{
      "hkey": "0f517929",
      "slug": "serravalle-mombarone",
      "name": "Serravalle-Mombarone",
      "primary": true,
      "skipSearch": false
    }],
    "valmairone": [{
      "hkey": "0f517929",
      "slug": "serravalle-mombarone",
      "name": "Serravalle-Mombarone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "6152da1b": [{
      "hkey": "b8d39d47",
      "slug": "madonna-di-viatosto-valmanera",
      "name": "Madonna di Viatosto-Valmanera",
      "primary": true,
      "skipSearch": false
    }],
    "valmanera": [{
      "hkey": "b8d39d47",
      "slug": "madonna-di-viatosto-valmanera",
      "name": "Madonna di Viatosto-Valmanera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "asti"
    }],
    "74864ec4": [{
      "hkey": "89eebbfd",
      "slug": "variglie-vallarone",
      "name": "Variglie-Vallarone",
      "primary": true,
      "skipSearch": false
    }],
    "variglie": [{
      "hkey": "89eebbfd",
      "slug": "variglie-vallarone",
      "name": "Variglie-Vallarone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;